import { Menu, Bell } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

interface HeaderProps {
  onMenuToggle: () => void
}

export function Header({ onMenuToggle }: HeaderProps) {
  const { user, logout } = useAuth()
  return (
    <header className="h-14 shrink-0 flex items-center justify-between px-4 border-b border-slate-800 bg-slate-900/80 backdrop-blur-sm sticky top-0 z-20">
      {/* Left: mobile menu toggle */}
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuToggle}
          className="lg:hidden p-2 rounded-lg text-slate-500 hover:text-slate-300 hover:bg-slate-800 transition-colors"
          aria-label="Toggle menu"
          id="mobile-menu-toggle"
        >
          <Menu size={18} />
        </button>

        {/* App version tag */}
        <span className="hidden sm:inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-slate-800 text-slate-500 border border-slate-700/50">
          MVP v0.1
        </span>
      </div>

      {/* Right: actions */}
      <div className="flex items-center gap-2">
        {/* Notification bell (placeholder) */}
        <button
          className="relative p-2 rounded-lg text-slate-500 hover:text-slate-300 hover:bg-slate-800 transition-colors"
          aria-label="Notifikasi"
          id="notifications-toggle"
        >
          <Bell size={16} />
        </button>

        {/* User avatar */}
        <button
          onClick={logout}
          className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-lg hover:bg-slate-800 transition-colors"
          id="user-menu-toggle"
          title="Logout"
        >
          <div className="w-6 h-6 rounded-full bg-gradient-to-br from-brand-600 to-brand-500 flex items-center justify-center">
            <span className="text-[10px] font-bold text-white">
              {user?.name?.charAt(0).toUpperCase() || 'U'}
            </span>
          </div>
          <span className="text-xs text-slate-400 hidden sm:block">
            {user?.name || 'User'}
          </span>
        </button>
      </div>
    </header>
  )
}
